<div class="form-row" [formGroup] *ngIf="isIdentitiesQual">
  <div class="col-12">
    <div class="form-group mb-05">
      <label>{{ "LABELS.BUSINESS_ID_NUMBER" | translate }}</label>
      <!--      <a href class="clear-qual" (click)="clearQualifier($event)">{{ "FORM_LABEL.CLEAR_ID_INFO" | translate }}</a>-->
      <div class="btn-group btn-group-qual" *ngIf="enumEntityModelCode.SHIP_TO !== this.code" id="entityIdentifierQualifier">
        <ng-container *ngFor="let qual of identitiesQual; let i = index">
          <button
            type="button"
            class="btn btn-primary"
            (click)="setIdentitiesQual(qual)"
            [ngClass]="{ 'is-active': identifierQualifierControl.value === qual.value }"
          >
            {{ getIdentifierQualifierTranslationKey(qual.key) | identifierQualifier | translate }}
          </button>
        </ng-container>
      </div>
      <app-control-errors
        [control]="identifierQualifierControl"
        [errors]="errors.identifierQualifier"
        [isShowHelper]="false"
        [isShowAlways]="true"
      ></app-control-errors>
    </div>
  </div>
  <!-- identifier -->
  <div class="col-12" [ngClass]="{ 'col-md-8': isShowDateOfBirth }">
    <app-control-wrapper [control]="identifierControl" [errors]="errors.identifier" [helper]="helperIdentifier">
      <label control-label for="identifier">{{ entityIdentifierLabel | translate }}</label>

      <app-search-wrapper [items]="isfEntities" [loading]="identifierLoading" (callback)="changeAddress($event)" control-wrapper>
        <input
          type="text"
          [formControl]="identifierControl"
          class="form-control"
          id="identifier"
          name="identifier"
          [attr.inputmode]="itemMask.inputmode"
          [placeholder]="itemMask.placeholder || ''"
          [mask]="itemMask.mask"
          [appMaskErrorTooltip]="itemMask.maskErrorTooltip"
          [maxMaskLength]="itemMask.maskMaxLength"
        />
      </app-search-wrapper>
    </app-control-wrapper>
  </div>
  <!-- date of birth control -->
  <ng-container *ngIf="isShowDateOfBirth">
    <div class="col-12 col-md-4">
      <date-picker
        [fc]="dateOfBirthControl"
        [errors]="errors.dateOfBirth"
        [id]="'dateOfBirth'"
        [name]="'dateOfBirth'"
        [label]="'LABELS.DATE_OF_BIRTH'"
        [placeholder]="'FORM_PLACEHOLDER.DATEOFBIRTH'"
      ></date-picker>
    </div>
  </ng-container>

  <!-- #7562 -->
  <!-- #12175 - removed validation text-->
</div>
